import isIframe from './isIframe'
import updateLinkParams from './updateLinkParams'
import makeFullUrl from './makeFullUrl'
import { URL_PARAMS_CONSTANTS } from '../Constants/global'


const forceUpdateUrl = (url = null) => {
  if (!url) {
    return url
  }

  const TOKEN_NAME = URL_PARAMS_CONSTANTS.SESSION_TOKEN
  const isLectoraFrame = isIframe()

  if (isLectoraFrame) {
    const tokenValue = new URL(window.location.href).searchParams.get(TOKEN_NAME) || null

    if (tokenValue) {
      const fullUrl = makeFullUrl(url)

      if (!fullUrl) {
        return url
      }

      const alreadyHasToken = String(fullUrl).includes(`${TOKEN_NAME}=${tokenValue}`)

      if (alreadyHasToken) {
        return fullUrl
      }

      return updateLinkParams(fullUrl, { [TOKEN_NAME]: tokenValue })
    }
  }

  return url
}

export default forceUpdateUrl
